// Central avatar registry — the single place that maps each Audience to its
// display metadata. Components read from here instead of branching on
// audience themselves, so adding/adjusting an audience never means hunting
// through per-component if/else or switch statements.

import type { Audience } from '@/types/domain';

export interface AvatarRegistryEntry {
  label: string;
  /** Accessible description of the body outline shown, independent of any fit shading. */
  alt: string;
}

export const AVATAR_REGISTRY: Record<Audience, AvatarRegistryEntry> = {
  women: {
    label: 'Women',
    alt: "Body outline used to show fit zones for women's garments",
  },
  men: {
    label: 'Men',
    alt: "Body outline used to show fit zones for men's garments",
  },
  child: {
    label: 'Youth',
    alt: 'Body outline for youth sizing (comparison engine not yet active)',
  },
};
